import React, { useState } from 'react';
import {
  Box,
  IconButton,
  Popover,
  Tooltip,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface MultiLineTooltipProps {
  tooltipContent: React.ReactNode;
  isMobileView?: boolean;
}

const arrowSize = 6;

const MultiLineTooltip: React.FC<MultiLineTooltipProps> = ({
  tooltipContent,
  isMobileView = false,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [arrowPosition, setArrowPosition] = useState<{ top: number; left: number } | null>(null);

  const open = Boolean(anchorEl);
  const id = open ? 'custom-popover' : undefined;

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (anchorEl) {
      setAnchorEl(null);
      setArrowPosition(null);
    } else {
      const rect = event.currentTarget.getBoundingClientRect();
      setAnchorEl(event.currentTarget);
      setArrowPosition({
        top: rect.top - arrowSize,
        left: rect.left + rect.width / 2 - arrowSize,
      });
    }
  };

  if (!isMobileView) {
    // Desktop Tooltip
    return (
      <Tooltip
        title={
          <Box sx={{ px: 1, py: 1, maxWidth: 350, minWidth: 250, fontSize: "0.875rem" }}>
            {tooltipContent}
          </Box>
        }
        arrow
        placement="top"
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: "rgba(97, 97, 97)",
              color: "#fff",
              borderRadius: 1,
              boxShadow: "-1px -1px 1px rgb(0 0 0 / 0.1)",
            },
          },
        }}
      >
        <IconButton sx={{ p: "0", color: "white" }}>
          <InfoOutlinedIcon />
        </IconButton>
      </Tooltip>
    );
  }
// Mobile tooltip
  return (
    <>
      <IconButton aria-describedby={id} onClick={handleClick} sx={{ p: "0", color: "white" }}>
        <InfoOutlinedIcon />
      </IconButton>

      {/* Custom Arrow rendered outside Popover */}
      {arrowPosition && (
        <Box
          sx={{
            position: "fixed",
            top: `${arrowPosition.top}px`,
            left: `${arrowPosition.left}px`,
            width: arrowSize * 2,
            height: arrowSize * 2,
            bgcolor: "rgba(97, 97, 97)",
            transform: "rotate(45deg)",
            zIndex: 1300,
            boxShadow: "-1px -1px 1px rgb(0 0 0 / 0.1)",
          }}
        />
      )}

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setArrowPosition(null);
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        disableRestoreFocus
        
        sx={{
          "& .MuiPaper-root": {
            position: "relative",
            backgroundColor: "rgba(97, 97, 97)",
            color: "#fff",
            px: 1.5,
            py: 1,
            borderRadius: 1,
            maxWidth: 250,
            fontSize: "0.875rem",
            boxShadow:"-1px -1px 1px rgb(0 0 0 / 0.1)",
          },
        }}
      >
        <Box>{tooltipContent}</Box>
      </Popover>
    </>
  );
};

export default MultiLineTooltip;

